<template>
  <div>
    <EmployeeSelection
      v-if="!employeeSelectionDisabled && !widgetSettings.bookingId"
    />
    <div v-if="availabilities.length === 0 && loadingAvailability">
      <IconSpinner />
    </div>
    <div v-else>
      <DatePicker />
      <div>
        <TimePicker @submit="$emit('submit')" />
      </div>
      <WaitingList
        v-if="settings.waiting_list"
        @submit="$emit('submit')"
        @back="$emit('back')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAvailabilityStore } from '@/stores/availability';
import { useCompanyStore } from '@/stores/company';

import IconSpinner from '@/components/IconSpinner.vue';
import widgetSettings from '@/widget-settings';
import EmployeeSelection from '../_shared/employee-selection/index.vue';
import DatePicker from './date-picker/DatePicker.vue';
import TimePicker from './time-picker/TimePicker.vue';
import WaitingList from './waiting-list/index.vue';

defineOptions({ name: 'ChooseDate' });
const emit = defineEmits(['submit', 'back']);

const { availabilities, loadingAvailability } = useAvailabilityStore();
const { employeeSelectionDisabled, settings } = useCompanyStore();
</script>

<style lang="scss" module>
.chooseEmployee {
  text-align: center;
  padding: $spacing;
}
</style>
./WaitingList.vue
